import { initializeApp, type FirebaseApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
  type Auth,
  type UserCredential,
} from 'firebase/auth';

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

function ensureInitialized(): Auth {
  if (auth) return auth;

  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY as string | undefined;
  const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined;
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined;

  if (!apiKey || !authDomain || !projectId) {
    throw new Error(
      'Firebase is not configured. Set VITE_FIREBASE_API_KEY, VITE_FIREBASE_AUTH_DOMAIN, and VITE_FIREBASE_PROJECT_ID.',
    );
  }

  app = initializeApp({
    apiKey,
    authDomain,
    projectId,
  });
  auth = getAuth(app);
  return auth;
}

export function isFirebaseConfigured(): boolean {
  return Boolean(
    import.meta.env.VITE_FIREBASE_API_KEY &&
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN &&
    import.meta.env.VITE_FIREBASE_PROJECT_ID,
  );
}

export async function signInWithGoogle(): Promise<{ idToken: string }> {
  const firebaseAuth = ensureInitialized();
  const provider = new GoogleAuthProvider();
  provider.addScope('email');
  provider.addScope('profile');

  const result: UserCredential = await signInWithPopup(firebaseAuth, provider);
  const idToken = await result.user.getIdToken();
  return { idToken };
}

export async function signOutFirebase(): Promise<void> {
  if (!auth) return;
  await firebaseSignOut(auth);
}
